import { DropdownObjectType } from '../types/interfaces';

export const PriorityOptions: DropdownObjectType[] = [
  { label: 'Высокий', key: 2 },
  { label: 'Средний', key: 1 },
  { label: 'Низкий', key: 0 }
];
